import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const ImproveFinancesIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });
  return (
    <Icon viewBox="0 0 73 73" {...rest} __css={styles}>
      <circle className="background" cx="36.5" cy="36.5" r="36.5" />
      <path
        className="accent"
        d="M52.6 36 37.7 13.5a1.4 1.4 0 0 0-2.5 0L20.4 36a1.5 1.5 0 0 0 0 1.4 1.4 1.4 0 0 0 1.2.8h6v20.5a1.4 1.4 0 0 0 1.5 1.5H44a1.4 1.4 0 0 0 1.4-1.5V38.1h6a1.4 1.4 0 0 0 1.3-.8 1.5 1.5 0 0 0 0-1.4Z"
      />
      <path
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
        d="M39.2 35.9a21.1 21.1 0 0 0-2.2-1 7.7 7.7 0 0 1-2.1-1.2 1.8 1.8 0 0 1-.6-1.4 2 2 0 0 1 .7-1.5 2.7 2.7 0 0 1 1.7-.6 2.8 2.8 0 0 1 2.2 1 1 1 0 0 0 .7.3 1 1 0 0 0 .5-.1 1 1 0 0 0 .5-.8 1 1 0 0 0-.2-.8 4.8 4.8 0 0 0-.7-.6 4.6 4.6 0 0 0-2-.8h-.2v-1.3a.8.8 0 0 0-.8-.7.8.8 0 0 0-.7.8v1.2h-.2a6.3 6.3 0 0 0-1.5.6 4.4 4.4 0 0 0-1.2.9 3.7 3.7 0 0 0-.7 1.1 3.5 3.5 0 0 0-.2 1.3 3.6 3.6 0 0 0 1 2.6 8.2 8.2 0 0 0 2.8 1.6l1.8.8a6 6 0 0 1 1 .7 2.3 2.3 0 0 1 .7 1.8 2.6 2.6 0 0 1-.9 2 3.2 3.2 0 0 1-2.2.8 3.2 3.2 0 0 1-2.1-.6 4.4 4.4 0 0 1-1-1.4 1 1 0 0 0-.9-.6 1 1 0 0 0-.2 0 1 1 0 0 0-.7.5 1 1 0 0 0 0 .9 5 5 0 0 0 1.2 1.8 6 6 0 0 0 3.2 1.3h.2v1.3a.7.7 0 0 0 .7.8.8.8 0 0 0 .8-.8v-1.3h.1a5.4 5.4 0 0 0 3-1.8 4.6 4.6 0 0 0 1-3 4 4 0 0 0-1.2-2.9 5.7 5.7 0 0 0-1.3-1Z"
      />
    </Icon>
  );
};

export default ImproveFinancesIcon;
